import { useRootStore } from '../index';
import { action, observable } from 'mobx';
import { ArticleQuery_article as Article } from '../../api';
import {
  DEFAULT_TAB,
  Tab
} from 'pages/Article/components/GoogleCampaignArticle/components/GoogleAssetsBuilder/utils/TabsDef';

export class GoogleAssetsBuilderStore {
  @observable article: Article | null = null;
  @action setArticle = (article: Article) => (this.article = article);

  @observable activeTab: Tab = DEFAULT_TAB;
  @action setActiveTab = (newTab: Tab) => (this.activeTab = newTab);
}

export const useGoogleAssetsBuilderStore = (): GoogleAssetsBuilderStore => {
  const store = useRootStore();
  if (!store.googleAssetsBuilderStore) throw new Error('Google Assets Builder store has not been initialized');
  return store.googleAssetsBuilderStore;
};
